<template>
  <div class="kPrdItem">
    <a :href="itemLink" :target="target">
      <div class="kPrdItem__picBox">
        <div class="kPrdItem__tags">
          <span v-if="periods" class="kPrdItem__tag">{{ periods }}</span>
          <span v-if="real" class="kPrdItem__tag">{{ real }}</span>
        </div>

        <img :src="img" :alt="title" />
        <div class="kPrdItem__id">{{ item.id }}</div>
      </div>
      <div class="kPrdItem--bd">
        <div class="kPrdItem__title">{{ title || '' }}</div>
        <div class="kPrdItem--des">{{ desc || '' }}</div>
        <slot name="btns">
          <div class="kPrdItem--btns"></div>
        </slot>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'kPrdItem',
  props: [
    'item',
    'img',
    'title',
    'desc',
    'price',
    'saleTag',
    'link',
    'periods',
    'target',
    'real',
  ],
  data() {
    return {}
  },
  computed: {
    itemLink() {
      return this.link ? this.link : 'javascript:;'
    },
  },
}
</script>

<style lang="less">
.kPrdItem {
  background: #fff;
  border-radius: 0.2rem;
  overflow: hidden;
  &__title {
    color: #2a2a2a;
    font-size: 0.28rem;
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
    display: block;
    padding: 0 0.2rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &__picBox {
    position: relative;
    top: 0;
    right: 0;
    img {
      width: 100%;
      display: block;
    }
  }
  &__id {
    position: absolute;
    right: 0;
    bottom: 0;
    font-size: .2rem;
    color: #fff;
    // opacity: .5;
    background: rgba(0,0,0, 0.2);
    border-radius:  .2rem0 0 0;
    padding: .05rem .2rem .03rem .2rem;
    // &::before {
    //     content: 'ID:';
    //     padding: 0 .1rem 0 0;
    //     opacity: .3;
    // }
  }
  &__tags {
    position: absolute;
    width: 100%;
    height: 100%;
    padding-top: 0.2rem;
  }
  &__tag {
    display: inline-block;
    padding: 0.05rem 0.15rem 0.05rem 0.12rem;
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 0.2rem;
    text-align: center;
  }
  &__tag + &__tag {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
    margin-left: 0.051rem;
  }
}
</style>
